import React from "react";

const Content = () => {
  return <div>Chat Content</div>;
};

export default Content;
